/** Karachi default center for maps / fallbacks */
export const KARACHI_CENTER = { lat: 24.8607, lng: 67.0011 };

let mapsScriptPromise: Promise<void> | null = null;

/** Loads Maps JS + Places (single script). */
export function loadGoogleMapsScript(apiKey: string): Promise<void> {
    if (typeof window === 'undefined') return Promise.reject(new Error('No window'));
    if (window.google?.maps?.Map && window.google?.maps?.places) return Promise.resolve();
    if (mapsScriptPromise) return mapsScriptPromise;

    const key = apiKey.trim();
    if (!key) return Promise.reject(new Error('Missing Google Maps API key'));

    mapsScriptPromise = new Promise((resolve, reject) => {
        const existing = document.querySelector('script[data-google-maps-app="1"]');
        if (existing) {
            const done = () => {
                if (window.google?.maps?.Map) resolve();
                else reject(new Error('Google Maps not available'));
            };
            if (window.google?.maps?.Map) {
                done();
                return;
            }
            existing.addEventListener('load', done);
            existing.addEventListener('error', () => reject(new Error('Google Maps script failed')));
            return;
        }
        const s = document.createElement('script');
        s.setAttribute('data-google-maps-app', '1');
        s.async = true;
        s.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&libraries=places`;
        s.onload = () => resolve();
        s.onerror = () => {
            mapsScriptPromise = null;
            reject(new Error('Failed to load Google Maps'));
        };
        document.head.appendChild(s);
    });
    return mapsScriptPromise;
}
